import {map as _map} from "lodash";
import * as React from "react";

export interface DietGuidelinesPlanPDFProps {
    id: string;
    planItem: any;
    imageUrl: string;
    includeBorder: boolean;
}

const DietGuidelinesPlanPDFTemplate: React.StatelessComponent<DietGuidelinesPlanPDFProps> = (props: DietGuidelinesPlanPDFProps) => {
    let id = props.id;
    let planItem = props.planItem;
    let itemToIterate = planItem[id];
    let imageUrl = props.imageUrl;
    let includeBorder = props.includeBorder;
    return (
        <div id={id} className={`prescription-grid-row external-row ${includeBorder ? "" : "no-border"}`}>
            <div className="prescription-card-content">
                <img className="prescription-sec-heading" src={imageUrl} />
                <div id={`${id}-subsection`} className="prescription-description">
                    {_map(itemToIterate, (guideline, index) => {
                        return <div key={`${guideline}-${index}`} className={"diet-guideline-item"}>{guideline.guideline}</div>;
                    })}
                </div>
            </div>
        </div>
    )
}

export default DietGuidelinesPlanPDFTemplate;